/*
  PDP — Sticky mobile Buy Now bar (Pause Rituals)
  • Slides up once the in-page CTA (.pdp-cta) scrolls out of view; hides while it's visible.
  • Buy Now → cart permalink (/cart/{variant}:1) using the LIVE selected variant → direct
    checkout with only this product (existing cart not included).
  • Keeps the bar's price in sync when the visitor changes variant.
  Idempotent; re-inits on Shopify section load (theme editor).
*/
(function () {
  function permalinkBase() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }

  function liveVariantId() {
    var input = document.querySelector(
      'product-form [name="id"], form[data-type="add-to-cart-form"] [name="id"], .product-variant-id'
    );
    return input && input.value ? input.value : null;
  }

  function setup(bar) {
    if (bar.dataset.stickyReady === '1') return;
    bar.dataset.stickyReady = '1';

    // ---- always visible on the PDP (no scroll-based hide/show) ----
    bar.classList.add('is-visible');

    // ---- reserve bottom space = bar height, so the footer never hides behind it ----
    function applySpacer() {
      var h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) {
        document.documentElement.style.setProperty('--pdp-sticky-h', h + 'px');
        document.body.classList.add('pdp-sticky-spacer');
      }
    }
    applySpacer();
    window.addEventListener('resize', applySpacer);
    window.addEventListener('load', applySpacer);

    // ---- Buy Now → permalink with the live variant id ----
    var btn = bar.querySelector('[data-pdp-sticky-buy]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        var vid = liveVariantId();
        if (vid) {
          e.preventDefault();
          window.location.href = permalinkBase() + '/cart/' + vid + ':1';
        }
        // else: fall back to the server-rendered href
      });
    }

    // ---- keep the bar's price in sync with the on-page price on variant change ----
    var priceEl = bar.querySelector('[data-sticky-price]');
    if (priceEl) {
      var sync = function () {
        var src = document.querySelector(
          '.pr-block__amount, .pdp-price-rating__amount .price-item--regular, .price-item--regular, .price__regular .price-item'
        );
        var txt = src && (src.textContent || '').trim();
        if (txt) priceEl.textContent = txt;
      };
      // Dawn re-renders the price section on variant change; observe the product-info subtree.
      var info = document.querySelector('product-info') || document.body;
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () { sync(); });
        mo.observe(info, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pdp-sticky]').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
